var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('m-side-panel-dialog',{attrs:{"close":_vm.close,"value":true}},[_c('m-user-details-carousel',{on:{"onUserChanged":_vm.loadUser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }